import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=d364513c&scoped=true"
import script from "./avatar.vue?vue&type=script&lang=js"
export * from "./avatar.vue?vue&type=script&lang=js"
import style0 from "./avatar.vue?vue&type=style&index=0&id=d364513c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d364513c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d364513c')) {
      api.createRecord('d364513c', component.options)
    } else {
      api.reload('d364513c', component.options)
    }
    module.hot.accept("./avatar.vue?vue&type=template&id=d364513c&scoped=true", function () {
      api.rerender('d364513c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personalDrive/avatar.vue"
export default component.exports